
const api = 'https://demo.softpulseinfotech.com/';
// https://demo.softpulseinfotech.com/reactjs-website/admin_cms/get_api.php
const basic_api="reactjs-website/admin_cms/get_api.php"
const contactUs_api="reactjs-website/admin_cms/react_mail.php"
const backgroundImage = require('./images/newsletter.jpg');
const proxyurl = "https://cors-anywhere.herokuapp.com/";
const imagePath="https://demo.softpulseinfotech.com/reactjs-website/admin_cms/image/"
const  get_json=async(self)=>{
	const requestOptions = {
	
		mode: 'no-cors',
		headers: {
			'Content-Type': 'application/json',
			"Access-Control-Allow-Origin": "*",
		  },
	
	};

    const url = api+"reactjs-website/admin_cms/get_api_json.php"
		await fetch(url)
		.then((response) => response.json())
	    .then((responseJson) => { 
			console.log(responseJson,"responseJson")
        self.setState({
		    	data:responseJson,
		    });
               localStorage.setItem('slider', JSON.stringify(self.state.data.slider));
               return("abcd")
    	})
    	.catch((error) => {
			console.log(error,"error")
            self.setState({data:'invalid'});
            return("invalid")
    	});
}
export {api,backgroundImage,get_json,basic_api,imagePath};
 
//https://demo.softpulseinfotech.com/reactjs-website/admin_cms/get_api_json.php